var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "20px",
        height: "20px",
        viewBox: "0 0 20 20",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "layer1" } }, [
        _c("path", {
          staticStyle: {
            "fill-opacity": "1",
            stroke: "none",
            "stroke-width": "0px",
          },
          attrs: {
            d: "M 18.646484 0.64648438 L 0.64648438 18.646484 L 1.3535156 19.353516 L 19.353516 1.3535156 L 18.646484 0.64648438 z M 0 3 L 0 14 L 2 14 L 2 15.878906 L 3 14.878906 L 3 13 L 1 13 L 1 4 L 13.878906 4 L 14.878906 3 L 0 3 z M 19.121094 3 L 18.121094 4 L 19 4 L 19 13 L 9.1210938 13 L 8.1210938 14 L 20 14 L 20 3 L 19.121094 3 z M 3 6 L 3 7 L 10.878906 7 L 11.878906 6 L 3 6 z M 3 8 L 3 9 L 8.8789062 9 L 9.8789062 8 L 3 8 z M 3 10 L 3 11 L 6.8789062 11 L 7.8789062 10 L 3 10 z M 12.121094 10 L 11.121094 11 L 16 11 L 16 10 L 12.121094 10 z ",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }